// Protern: shared thumbnail video player
(function () {
  function onClick(e) {
    const poster = e.target.closest('.protern-video__poster');
    if (!poster) return;

    const wrapper = poster.closest('.protern-video');
    if (!wrapper) return;

    const player = wrapper.querySelector('.protern-video__player');
    if (!player) return;

    // Hide poster, show player
    poster.style.display = 'none';
    player.style.display = 'block';

    const video = player.querySelector('video');
    if (!video) return;

    // Always loop
    video.loop = true;

    // Start from the beginning every time the user clicks play
    try {
      // Some browsers can throw if metadata is not ready yet
      video.currentTime = 0;
    } catch (err) {}

    // If metadata is not loaded yet, ensure we still start at 0 when it is
    const ensureStartAtZero = function () {
      try { video.currentTime = 0; } catch (err) {}
      video.removeEventListener('loadedmetadata', ensureStartAtZero);
    };
    video.addEventListener('loadedmetadata', ensureStartAtZero);

    // Play
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  // Capture phase helps if themes stop propagation in bubbling phase
  document.addEventListener('click', onClick, true);
})();